if (!customElements.get('size-quick-add')) {
  customElements.define(
    'size-quick-add',
    class SizeQuickAdd extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.querySelector('.size-quick-add__toggle');
        this.panel = this.querySelector('.size-quick-add__panel');
        this.form = this.querySelector('form');
        this.idInput = this.form.querySelector('input[name="id"]');
        this.hiddenSubmit = this.querySelector('.size-quick-add__hidden-submit');

        this.toggle.addEventListener('click', this.onToggleClick.bind(this));
        this.panel.addEventListener('click', this.onPanelClick.bind(this));
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
      }

      get isOpen() {
        return !this.panel.hidden;
      }

      onToggleClick(event) {
        event.preventDefault();
        this.isOpen ? this.close() : this.open();
      }

      open() {
        document.querySelectorAll('size-quick-add').forEach((other) => {
          if (other !== this) other.close();
        });

        this.panel.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.keepPanelOnScreen();
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keyup', this.onKeyUp);
      }

      // CSS centers the panel under its trigger (left: 50%; transform:
      // translateX(-50%) — component-size-quick-add.css), which reads fine
      // for a card in the middle of a row, but a card near the left/right
      // edge of the screen (the outer column of whatever grid it happens
      // to be in) can still push the centered panel partway off-screen.
      // Previously "fixed" with hardcoded odd/even-column left offsets
      // tuned for one specific grid — broke for any other column count/
      // layout, which is exactly the overflow this was reported for.
      // Measuring the panel's REAL position against the REAL viewport
      // after every open, and nudging it back by however many px it
      // actually overflows, works for any card position/grid shape
      // instead of assuming one.
      keepPanelOnScreen() {
        // Reset first — otherwise a previous open's nudge would keep
        // compounding onto itself (e.g. if the window was resized, or a
        // different card's panel was clamped differently) each time this
        // one reopens.
        this.panel.style.transform = '';

        const margin = 8; // px kept clear of the viewport edge
        const rect = this.panel.getBoundingClientRect();
        // document.documentElement.clientWidth, not window.innerWidth —
        // innerWidth includes a vertical scrollbar's own width where one is
        // present, overestimating how much room is actually visible.
        // base.css's body { overflow-x: hidden } (component-mega-menu.css)
        // clips at the narrower true content width, so measuring against
        // the wider innerWidth could let a few pixels of the panel sit
        // inside that clipped-away sliver on any page tall enough to have
        // a scrollbar.
        const viewportWidth = document.documentElement.clientWidth;
        const overflowRight = rect.right - (viewportWidth - margin);
        const overflowLeft = margin - rect.left;

        if (overflowRight > 0) {
          this.panel.style.transform = `translateX(calc(-50% - ${overflowRight}px))`;
        } else if (overflowLeft > 0) {
          this.panel.style.transform = `translateX(calc(-50% + ${overflowLeft}px))`;
        }
      }

      close() {
        if (!this.isOpen) return;
        this.panel.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keyup', this.onKeyUp);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeyUp(event) {
        if (event.code?.toUpperCase() !== 'ESCAPE') return;
        this.close();
        this.toggle.focus();
      }

      onPanelClick(event) {
        const pill = event.target.closest('.size-quick-add__pill');
        if (!pill || pill.disabled) return;

        this.idInput.value = pill.dataset.variantId;
        this.idInput.disabled = false;
        this.close();
        this.form.requestSubmit(this.hiddenSubmit);
      }
    }
  );
}
